import {gsap} from "../LibrariesImport";
export default class BlockListingProducts {
	static init() {
		this.sliders = document.querySelectorAll(".block-listing-products");

		if(!this.sliders) {
			return;
		}

		this.buildSliders();
	}

	static buildSliders() {
		this.sliders.forEach(slider => {
			const stage = slider.querySelector(".swiper-product");
			const drag = slider.querySelector(".swiper-scrollbar");
			// const canvas = slider.querySelector("canvas");
			const swiper = new Swiper(stage, {
				loop: false,
				grabCursor: true,
				slidesPerView: "auto",
				spaceBetween: 0,
				speed: 500,
				touchEventsTarget: "container",
				mousewheel: {
					enabled: true,
					releaseOnEdges: true,
					forceToAxis: true,
				},
				scrollbar: {
					el: drag,
					draggable: true,
					snapOnRelease: false,
				},
				on:{
					touchStart: () => {

					},
					touchMove: (swiper, e) => {
						let sliderOffset = slider.getBoundingClientRect();


					},
					touchEnd: () => {
					},
					lock: () => {
						stage.classList.remove("swiper-is-active");
					},
					unlock: () => {
						stage.classList.add("swiper-is-active");
					},
					resize: (swiper) => {

					}
				}
			});


		});
	}
}